import { useEffect } from "react";
import Lottie from "lottie-react";
import lottieAnim from "../../../assets/lottie/Logik.json";

export default function Delfraser({
  pauseAll,
  lottieRef,
  htmlRef,
}: {
  pauseAll: (lottieRef: any) => void;
  lottieRef: any;
  htmlRef: any;
}) {
  useEffect(() => {
    const playVideoWhenInView = (entries: IntersectionObserverEntry[]) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          pauseAll(lottieRef);
          lottieRef.current?.play();
        } else {
          lottieRef.current?.pause();
        }
      });
    };

    const options = {
      root: null,
      rootMargin: "0px",
      threshold: 1,
    };

    const observer = new IntersectionObserver(playVideoWhenInView, options);

    if (htmlRef.current) {
      observer.observe(htmlRef.current);
    }

    return () => {
      observer.disconnect();
    };
  }, [htmlRef, lottieRef, pauseAll]);

  return (
    <div className="mx-auto md:py-32 grid grid-cols-1 border-b md:border-none md:grid-cols-2 mx-auto items-center gap-4 items-start container pb-[15px] md:pb-[40px] mb-8 md:pb-0">
      <div className="flex md:container justify-center">
        <div ref={htmlRef} className="player w-full">
          <Lottie
            animationData={lottieAnim}
            autoplay={false}
            lottieRef={lottieRef}
            loop={true}
            className="player"
          />
        </div>
      </div>
      <div className="mb-6 md:mb-0 md:container">
        <h2 className="text-dxl md:text-d2xl font-bold text-doctio-green">
          Dynamiske fraser bygget på logikker
        </h2>
        <p>
          Doctio Pro tilbyder dynamiske fraser der bygger på logikker
          (algoritmer) fra forskellige nationale- og internationale
          behandlingsvejledninger. En helt ny og revolutionerende måde at
          journalføre på. Via klikelementer “lytter” fraserne på de valg der
          indtastes, og via en bagvedliggende logik kan fraserne automatisk give
          forslag til behandlingsplaner mm. Det er dog fortsat klinikerens
          ansvar at sikre at behandlingsplanen passer til den enkelte
          patientkonsultation.
        </p>
        <a href="/signup" className="text-doctio-green font-bold">
          Opret dig som Doctio Pro bruger
        </a>
      </div>
    </div>
  );
}
